import type { Lang } from '~/types';
import { useStore } from '@tanstack/react-store';
import { useFeatureFlagPayload } from 'posthog-js/react';
import { useEffect, useState } from 'react';
import { langStore } from '~/store/langStore';
import LayeredButton from './LayeredButton';

export function StickyFooter() {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return <StickyFooterClient />;
}

function StickyFooterClient() {
  const lang = useStore(langStore, state => state);
  type FooterTextPayload = {
    [K in Lang]?: {
      text: string;
      link: string;
      linkText: string;
    };
  };
  const payload = useFeatureFlagPayload('footer-text') as FooterTextPayload | null;

  if (lang === 'EN' || !payload || typeof payload !== 'object' || !payload[lang]) {
    return null;
  }

  return (
    <div className="bg-orange fixed bottom-0 left-0 flex w-full items-center justify-center gap-2 p-4 text-center text-sm text-black">
      <span>{payload[lang].text}</span>
      {payload[lang].link && payload[lang].linkText
        ? (
            <a
              href={payload[lang].link}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2"
            >
              <LayeredButton text={payload[lang].linkText} />
            </a>
          )
        : null}
    </div>
  );
}
